import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { IBitfOkCancelDialogData, IBitfCloseEvent } from '@interfaces';
import { EBitfCloseEventStatus } from '@enums';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'bitf-bitf-mat-ok-cancel-dialog',
  templateUrl: './bitf-mat-ok-cancel-dialog.component.html',
  styleUrls: ['./bitf-mat-ok-cancel-dialog.component.scss'],
})
export class BitfMatOkCancelDialogComponent {
  form: FormGroup;

  constructor(
    public dialogRef: MatDialogRef<BitfMatOkCancelDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public dialogData: IBitfOkCancelDialogData,
    private formBuilder: FormBuilder
  ) {
    if (dialogData.prompt) {
      this.form = this.formBuilder.group({
        value: [dialogData.prompt.value || '', dialogData.prompt.isRequired ? Validators.required : ''],
      });
    }
  }

  onOk() {
    this.dialogRef.close({
      status: EBitfCloseEventStatus.OK,
      data: this.form && this.form.value,
    } as IBitfCloseEvent<void>);
  }

  onCancel() {
    this.dialogRef.close({
      status: EBitfCloseEventStatus.CANCEL,
    } as IBitfCloseEvent<void>);
  }
}
